import { ACCESS_LEVEL_VIEW } from "../../../../constants";

const shouldShowToBagButton = ({
  isProductInStock,
  isVariantInStock,
  customerAccess
}) =>
  isProductInStock &&
  isVariantInStock !== false &&
  customerAccess !== ACCESS_LEVEL_VIEW;

export default shouldShowToBagButton;
